import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3105, { U3105ROLES } from "./U3105";
import U3105PayrollYearList from "./components/U3105PayrollYearList";
import U3105PayrollYearForm from "./components/U3105PayrollYearForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3105Routes: RouteObject[] = [
  {
    path: "U3105",
    element: <U2000RequireRole allowedRoles={[U3105ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3105 />,
        children: [
          { index: true, element: <U3105PayrollYearList /> },
          { path: ":id", element: <U3105PayrollYearForm /> },
        ],
      },
    ],
  },
];

export default U3105Routes;
